import { FC, PropsWithChildren } from 'react';
import styles from './InlineFilterGroup.css';

export const InlineFilterGroup: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
